import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=5c96f3a2&scoped=true&"
import script from "./Monitor.vue?vue&type=script&lang=js&"
export * from "./Monitor.vue?vue&type=script&lang=js&"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=5c96f3a2&prod&lang=css&"
import style1 from "./Monitor.vue?vue&type=style&index=1&id=5c96f3a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96f3a2",
  null
  
)

export default component.exports